import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  container: {
    position: "relative",
    minHeight: "calc(100vh - 300px)",
    paddingBottom: "40px",
  },
  buttons: {
    position: "absolute",
    bottom: 0,
    right: "7px",
  },
  title: {
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: 20,
    color: "#465869",
    lineHeigth: "140%",
  },
  separator: {
    backgroundColor: "#E0E2E7",
    height: "1px",
    width: "100%",
    margin: "32px 0px",
  },
  paymentContainer: {
    marginTop: "24px",
    marginBottom: 16,
  },
  label: {
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: 16,
    color: "#465869",
  },
  totalCostContainer: {
    marginTop: 32,
    maxWidth: "30%",
  },
  consultantName: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: 14,
    color: "#465869",
    lineHeight: "150%",
    marginTop: 16,
  },
  smallSpacing: {
    marginTop: 16,
  },
  signature: {
    marginTop: 44,
  },
  badge: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#F8F9FC",
    minWidth: "80px",
    padding: "6px 16px",
    height: "40px",
    borderRadius: "20px",
  },
  textBadge: {
    marginLeft: 12,
    color: "#465869",
    fontFamily: "Manrope",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "160%",
  },
  signatureName: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: 14,
    color: "#465869",
    lineHeight: "100%",
  },
  buttonSign: {
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: 14,
    lineHeigth: 14,
    boxSizing: "border-box",
    borderRadius: 4,
    border: "1px solid #E4E7EC",
    width: "180px",
    height: "74px",
    color: "#308CDB",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-end",
    padding: "0px 0px 7px 10px",
    marginBottom: "4px",
  },
  buttonError: {
    border: "1px solid #D92D20 !important",
  },
  centralize: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderBottom: "1px solid",
  },
  mr5: {
    marginRight: "5px",
  },
  w50: {
    width: "50%",
  },
  mb16: {
    marginBottom: 16,
  },
}));

export default styles;
